import { render, staticRenderFns } from "./PubOffers.vue?vue&type=template&id=2ecda4c6&scoped=true&"
import script from "./PubOffers.vue?vue&type=script&lang=js&"
export * from "./PubOffers.vue?vue&type=script&lang=js&"
import style0 from "vue-multiselect/dist/vue-multiselect.min.css?vue&type=style&index=0&lang=css&"
import style1 from "./PubOffers.vue?vue&type=style&index=1&id=2ecda4c6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ecda4c6",
  null
  
)

export default component.exports